import Vue from "vue";
import VueApplicationInsights from "vue-application-insights";
import router from "@/router";

Vue.use(VueApplicationInsights, {
  id: process.env.VUE_APP_APPINSIGHTS_KEY,
  router
});
